<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <v-card class="mb-0">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Cancelar Deuda de Cuenta Corriente</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <v-row dense>
            <v-col cols="12">
              <v-alert color="error" outlined dense>
                Saldo deudor: ${{ saldoDeudor.toFixed(2) }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="jugadorNombre"
                prepend-icon="mdi-account"
                label="Jugador"
                readonly
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="monto"
                prepend-icon="mdi-currency-usd"
                label="Monto a cancelar *"
                :rules="montoRules"
                @keypress="onlyNumber"
                @blur="toFixed"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-select
                v-model="idFormaPago"
                :items="formasPago"
                item-text="nombreFormaPago"
                item-value="idFormaPago"
                prepend-icon="mdi-credit-card"
                label="Forma de pago *"
                :rules="[(v) => !!v || 'Dato obligatorio']"
                dense
                no-data-text="No hay formas de pago configuradas"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey lighten-1" @click.stop="show = false">
          Cancelar
        </v-btn>
        <v-btn color="success" :disabled="!valid" @click.stop="cancelarDeuda">
          Registrar Pago
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    saldoDeudor: {
      type: Number,
      required: true,
      default: 0,
    },
    idPaciente: {
      type: Number,
      required: false,
      default: null,
    },
    jugadorNombre: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      valid: false,
      lazy: false,
      monto: null,
      observaciones: "",
      idFormaPago: null,
      formasPago: [],
      montoRules: [
        (v) => !!v || "Dato obligatorio",
        (v) => parseFloat(v) > 0 || "El monto debe ser mayor a 0",
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  watch: {
    visible(val) {
      if (val) this.cargarFormasPago();
    },
  },
  methods: {
    toFixed() {
      if (isNaN(parseFloat(this.monto)))
        this.monto = parseFloat(0.0).toFixed(2);
      else this.monto = parseFloat(this.monto).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        $event.preventDefault();
      }
    },
    vaciarModels() {
      this.monto = null;
      this.observaciones = "";
      this.idFormaPago = null;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async cargarFormasPago() {
      try {
        const { data } = await axios.get("/Caja/BuscarFormasPago");
        // Excluir Mercado Pago (id 5) y Cuenta Corriente (id 7)
        this.formasPago = (data || []).filter(
          (fp) => fp.idFormaPago !== 5 && fp.idFormaPago !== 7,
        );
      } catch {
        this.formasPago = [];
      }
    },
    cancelarDeuda() {
      this.$swal({
        title: "Cancelar Deuda",
        text: "¿Desea registrar este pago para cancelar deuda del jugador?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datos = {
            idJugador: this.idPaciente,
            importe: parseFloat(this.monto),
            observaciones: this.observaciones,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idFormaPago: this.idFormaPago,
            paciente: this.jugadorNombre,
            usuario: this.$store.state.usuario.usuario,
          };
          let self = this;
          axios
            .post("/Caja/CancelarDeudaCuentaCorriente", datos)
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Pago registrado exitosamente.",
                vm: self,
                timer: 2000,
              });
              self.vaciarModels();
              self.$emit("pagado");
              self.show = false;
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "No se pudo registrar el pago.",
                vm: this,
                timer: 2000,
              });
            });
        }
      });
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
};
</script>
